import {
  IRegisterExitAction,
  RegisterExitState,
} from "../actions/types/registerExitTypes";

const initialState: RegisterExitState = {
  loadingScan: false,
  loadingSearch: false,
  loadingSelecting: false,
  listPeopleInside: [],
  paginationPage: 0,
  pageCount: 1,
  searchValue: "",
  sortBy: "datetime",
  sortByDirection: "asc",
  openedVehicleSection: false,
};

export const registerExitReducer = (
  state: RegisterExitState = initialState,
  action: IRegisterExitAction<any>,
): RegisterExitState => {
  switch (action.type) {
    case "FILL_LIST_PEOPLEINSIDE":
      return {
        ...state,
        listPeopleInside: action.payload,
      };
    case "SET_LOADING_PEOPLEINSIDE_SCAN":
      return {
        ...state,
        loadingScan: action.payload,
      };
    case "SET_LOADING_PEOPLEINSIDE_SEARCH":
      return {
        ...state,
        loadingSearch: action.payload,
      };
    case "SET_LOADING_PEOPLEINSIDE_SELECTING":
      return {
        ...state,
        loadingSelecting: action.payload,
      };
    case "SET_PAGINATION_PAGE":
      return {
        ...state,
        paginationPage: action.payload,
      };
    case "SET_PAGE_COUNT":
      return {
        ...state,
        pageCount: action.payload,
      };
    case "SET_SEARCH_VALUE":
      return {
        ...state,
        searchValue: action.payload,
      };
    case "SET_SORT_BY":
      return {
      ...state,
      sortBy: action.payload,
     };
    case "SET_SORT_BY_DIRECTION":
        return {
        ...state,
        sortByDirection: action.payload,
     };
    case "OPENED_VEHICLE_SECTION":
      return {
          ...state,
          openedVehicleSection: action.payload,
      };
    default:
      return state;
  }
};
